import Button, { ButtonProps } from "atoms/buttons/button";
import Icon from "atoms/icons/icon";
import React, { forwardRef, useMemo } from "react";
import { Icons } from "atoms/constants/icons";
import { useLocalization } from "utilities/hooks/use-localization";
import usePageActionPermission, {
    PageAction,
} from "pages/notebooks/use-page-action-permission";
import PageRecord from "models/view-models/page-record";
import DeprecatedShow from "atoms/wrappers/show";
import { IconSizes } from "atoms/constants/icon-sizes";

export interface DeletePageMenuItemProps extends ButtonProps {
    page: PageRecord;
    onClick: () => void;
}
const CSS_CLASS_NAME = "c-page-context-menu";

const DeletePageMenuItem = forwardRef<
    HTMLButtonElement,
    DeletePageMenuItemProps
>((props, ref) => {
    const { page, onClick, children, ...rest } = props;
    const { t } = useLocalization();
    const { can } = usePageActionPermission(page);
    const canDelete = useMemo(() => can(PageAction.Delete), [can]);

    return (
        <DeprecatedShow when={canDelete}>
            <Button
                ref={ref}
                accessibleText={t("deleteItem", {
                    item: t("page"),
                })}
                cssClassName={`${CSS_CLASS_NAME}__button delete-button`}
                onClick={onClick}
                {...rest}
                dataTestId="notebook-page--page-context-menu--delete-page-button">
                <Icon type={Icons.Trashcan} size={IconSizes.Small} />
                {t("deleteItem", {
                    item: t("page"),
                })}
            </Button>
        </DeprecatedShow>
    );
});

export default DeletePageMenuItem;
